import React, { useContext, useEffect, useRef, useState } from 'react'

import Card from '../../../Base/Components/Card/Card'
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek'
import { getDateTimeString, getDatesProduccion, getDatesProduccionOutHours } from '../../../Base/Services/Moment/Luxon';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import ModalFull from '../../../Base/Components/Dialog/ModalFull';

import { getListadoDetalleOrdenes, getListadoOrdenes, postCantidadRecibidaDetalle, postCantidadReservadaDetalle } from '../../../API/Compras/Ordenes/OrdenesComprasRequests';
import { getPermisoCostosUser } from '../../../API/IT/Usuarios/AccesosUserRequets';
import { TabPanel, TabView } from 'primereact/tabview';
import OrdenesComprasCrud from './OrdenesComprasCrud';
import { Button } from 'primereact/button';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';
import { toastShow } from '../../../Base/Services/ToastService';
import { Toast } from 'primereact/toast';
import { SplitButton } from 'primereact/splitbutton';
import OrdenesComprasReporte from './Reporte/OrdenesComprasReporte';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

const OrdenesComprasScreen = () => {

    const { userAuth } = useContext(AuthContext);

    const toast = useRef(null);
    const [permisoCostos, setpermisoCostos] = useState(false);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [loading, setLoading] = useState(false);
    const [dataOrdenes, setDataOrdenes] = useState([]);
    const [dataDetalle, setDataDetalle] = useState([]);
    const [selected, setSelected] = useState([]);
    const [selectedDetalle, setSelectedDetalle] = useState([]);
    const [ordenDialog, setOrdenDialog] = useState(false);
    const [orderToShow, setOrderToShow] = useState(null);
    const [habilitar, setHabilitar] = useState(false);
    const [showReporte, setShowReporte] = useState(false);
    const [lenguaje, setLenguaje] = useState('es');

    const getInfo = async () => {
        setLoading(true);

        const p = await getPermisoCostosUser(userAuth.idUser);
        if (p.length > 0) {
            setpermisoCostos(p[0].acceso);
        }
        const f = getDatesProduccionOutHours(dates);
        const t = await getListadoOrdenes(f);
        const d = await getListadoDetalleOrdenes(f);
        setDataOrdenes(t);
        setDataDetalle(d);
        setLoading(false);
    }
    

    const columnOrdenes = [
        {
            field: 'IdPurchaseOrder',
            header: 'ID',
            className: "Xsmall",
            alignFrozen: "left",
            frozen: "frozen",
            hidden: userAuth.IdRol === 1,
        },
        {
            // FECHA CREADO
            field: 'OrderDate',
            header: 'Fecha Creado',
            className: "small",
            alignFrozen: "left",
            frozen: "frozen",
            Format: 'Date',

        },
        {
            // ESTADO
            field: 'Estado',
            header: 'Estado',
            className: "Xsmall",
            body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.StatusName }),
            frozen: "frozen",
            alignFrozen: "left",
            Format: 'Estado'
        },
        {
            // NUMERO ORDEN
            field: 'PurchaseOrder',
            header: 'No. Orden',
            className: "small",
            frozen: "frozen",
            alignFrozen: "left",
            Sumary: 'count',
            align: 'center',
            Format: 'Modal'
        },
        {
            // PROVEEDOR
            field: 'Vendor',
            header: 'Proveedor',
            className: "XXlarge",
            Format: 'LongText'
        },
        {
            // AGENTE
            field: 'AgentName',
            header: 'Agente',
            className: "large",
        },
        {
            // TERMINOS
            field: 'TermName',
            header: 'Terminos',
            className: "large",
        },
        {
            // CLIENTE ***********
            field: 'CustomerName',
            header: 'Cliente',
            className: "large",
        },
        {
            // MONEDA
            field: 'CurrencySymbol',
            header: 'Moneda',
            className: "small",
            align: 'center'
        },
        {
            // TIPO COMPRA
            field: 'PurchaseType',
            header: 'Tipo Compra',
            className: "medium",
        },
        {
            // AREA SOLICITA
            field: 'Area',
            header: 'Area',
            className: "Xlarge",
        },
        {
            // ENTREGAR A
            field: 'Address',
            header: 'Entregar a',
            className: "Xlarge",
        },
        {
            // Comentarios
            field: 'Description',
            header: 'Comentario',
            className: "Xlarge",
        },
        {
            // Fecha desde
            field: 'FechaDesde',
            header: 'Fecha Desde',
            className: "small",
            Format: 'Date',
        },
        {
            // Fecha hasta
            field: 'FechaHasta',
            header: 'Fecha Hasta',
            className: "small",
            Format: 'Date',
        },
        {
            // tipo descuento
            field: 'TipoDescuentoD',
            header: 'TipoDescuento',
            className: "Xsmall",
            align: 'center'
        },
        {
            field: 'SubTotal',
            header: 'SubTotal',
            className: "small",
            frozen: "frozen",
            alignFrozen: "right",
            Sumary: 'sum',
            Format: 'Currency',
            hidden: permisoCostos,
        },
        {
            field: 'Freights',
            header: 'Freights',
            className: "Xsmall",
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
            Sumary: 'sum',
            Format: 'Currency'
        },
        {
            field: 'Tax',
            header: 'Tax',
            className: "Xsmall",
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
            Sumary: 'sum',
            Format: 'Currency'
        },
        {
            field: 'Otros',
            header: 'Otros',
            className: "Xsmall",
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
            Sumary: 'sum',
            Format: 'Currency'
        },
        {
            field: 'Discount',
            header: 'Descuento',
            className: "Xsmall",
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
            Sumary: 'sum',
            Format: 'Currency'
        },
        {
            field: 'Total',
            header: 'Total',
            className: "small",
            frozen: "frozen",
            alignFrozen: "right",
            Sumary: 'sum',
            Format: 'Currency',
            hidden: permisoCostos,
        },
    ];

    const columnDetalle = [
        {
            field: 'IdPurchaseOrderDetail',
            header: 'ID',
            className: "Xsmall",
            alignFrozen: "left",
            frozen: "frozen",
            hidden: userAuth.IdRol === 1,
        },
        {
            // FECHA CREADO
            field: 'OrderDate',
            header: 'Fecha Creado',
            className: "small",
            alignFrozen: "left",
            frozen: "frozen",
            Format: "Date",
        },
        {
            // ESTADO
            field: 'Estado',
            header: 'Estado',
            className: "Xsmall",
            body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.Estado }),
            frozen: "frozen",
            alignFrozen: "left",
            Format: 'Estado'
        },
        {
            // NUMERO ORDEN
            field: 'PurchaseOrder',
            header: 'No. Orden',
            className: "small",
            frozen: "frozen",
            alignFrozen: "left",
            Format: 'Modal',
            Sumary: 'count',
        },
        {
            // CODIGO PRODUCTO
            field: 'CodigoProducto',
            header: 'CodigoProducto',
            className: "medium",
        },
        {
            // NOMBRE PRODUCTO
            field: 'NombreProducto',
            header: 'Producto',
            className: "medium",
        },
        {
            // PROVEEDOR
            field: 'Vendor',
            header: 'Proveedor',
            className: "Xlarge",
        },
        {
            // AREA SOLICITA
            field: 'AreaSolicita',
            header: 'Área',
            className: "medium",
        },
        {
            // CATEGORIA
            field: 'NombreCategoria',
            header: 'Nombre Categoria',
            className: "medium",
        },
        {
            // MONEDA
            field: 'CurrencySymbol',
            header: 'Moneda',
            className: "small",
            align: 'center'

        },
        {
            // AGENTE
            field: 'AgentName',
            header: 'Agente',
            className: "large",
        },
        {
            // Comentarios
            field: 'Description',
            header: 'Comentario',
            className: "Xlarge",
        },
        {
            // SUBCATEGORIA
            field: 'NombreSubCategoria',
            header: 'Subcategoria',
            className: "medium",
        },
        {
            // REQUISA
            field: 'PurchaseRequest',
            header: 'Requisa',
            className: "small",
        },
        {
            // ITEM
            field: 'IdRequest',
            header: 'Item',
            className: "small",
            align: 'center',
        },
        {
            // ITEM
            field: 'KgsPR',
            header: 'Kgs',
            className: "small",
            Format: 'Decimal',
            Sumary: 'sum',
        },
        {
            // ORDENADO
            field: 'QtyOrdered',
            header: 'Ordenado',
            className: "small",
            Format: 'Decimal',
            Sumary: 'sum',
        },
        {
            // RECEIVE
            field: 'QtyReceive',
            header: 'RECEIVE',
            className: "small",
            Format: 'Decimal',
            sortable: true,
            editable: userAuth?.IdRol === 1,
            onChange: (data) => {
                let row = data?.data
                let tempo = [...dataDetalle]
                if (data?.newValue >= 0) {
                    let message = <div>¿Está seguro cambiar la cantidad recibida del detalle?</div>
                    confirmDialog({
                        message: message,
                        header: 'Confirmación',
                        icon: 'pi pi-exclamation-triangle',
                        accept: async () => {
                            let datosEnviar = {
                                IdPurchaseOrderDetail: row.IdPurchaseOrderDetail,
                                QtyReceive: data.newValue
                            }

                            const tempoResult = await postCantidadRecibidaDetalle(datosEnviar)
                            if (tempoResult?.length > 0) {
                                if (tempoResult[0]?.ERROR === 0) {
                                    row.QtyReceive = data?.newValue
                                    let index = tempo.findIndex((t) => t.IdPurchaseOrderDetail === row?.IdPurchaseOrderDetail)
                                    tempo[index] = row
                                    setDataDetalle(tempo)

                                    getInfo()
                                }
                                else {
                                    toastShow(toast, 'error', tempoResult[0]?.MSJ)
                                }
                            }
                        },
                        reject: () => {
                            row.QtyReceive = data?.oldValue
                            let index = tempo.findIndex((t) => t.IdPurchaseOrderDetail === row?.IdPurchaseOrderDetail)
                            tempo[index] = row

                            setDataDetalle(tempo)
                        }

                    })
                }
            },
            Sumary: 'sum',
        },
        {
            // RECEIVE
            field: 'QtyReserved',
            header: 'RESERVED',
            className: "small",
            Format: 'Decimal',
            editable: userAuth?.IdRol === 1,
            onChange: (data) => {
                let row = data?.data
                let tempo = [...dataDetalle]
                if (data?.newValue >= 0) {
                    let message = <div>¿Está seguro cambiar la cantidad reservada del detalle?</div>
                    confirmDialog({
                        message: message,
                        header: 'Confirmación',
                        icon: 'pi pi-exclamation-triangle',
                        accept: async () => {
                            let datosEnviar = {
                                IdPurchaseOrderDetail: row.IdPurchaseOrderDetail,
                                QtyReserved: data.newValue
                            }

                            const tempoResult = await postCantidadReservadaDetalle(datosEnviar)
                            if (tempoResult?.length > 0) {
                                if (tempoResult[0]?.ERROR === 0) {
                                    row.QtyReserved = data?.newValue
                                    let index = tempo.findIndex((t) => t.IdPurchaseOrderDetail === row?.IdPurchaseOrderDetail)
                                    tempo[index] = row
                                    setDataDetalle(tempo)

                                    getInfo()
                                } else {
                                    toastShow(toast, 'error', tempoResult[0]?.MSJ)
                                }
                            }
                        },
                        reject: () => {
                            row.QtyReserved = data?.oldValue
                            let index = tempo.findIndex((t) => t.IdPurchaseOrderDetail === row?.IdPurchaseOrderDetail)
                            tempo[index] = row

                            setDataDetalle(tempo)
                        }

                    })
                }
            },
            Sumary: 'sum',
        },
        {
            // BALANCE
            field: 'BalancePOD',
            header: 'Balance',
            className: "small",
            Format: 'Decimal',
            Sumary: 'sum',
        },
        {
            // UNIDAD
            field: 'UnitSimbol',
            header: 'Unidad',
            className: "Xsmall",
            body: (rowData) => (rowData.UnitSimbol),
            align: 'center',
        },
        {
            // PRECIO
            field: 'UnitPrice',
            header: 'Precio',
            className: "Xsmall",
            Format: 'Currency',
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
            //   Sumary: 'sum',
        },
        // SUBTOTAL
        {
            field: 'Subtotal',
            header: 'Subtotal',
            className: "small",
            Format: 'Currency',
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
            Sumary: 'sum',
        },

        // DESCUENTO
        {
            field: 'Discount',
            header: 'Descuento',
            className: "Xsmall",
            Format: 'Currency',
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
            Sumary: 'sum',
        },
        // TOTAL
        {
            field: 'Total',
            header: 'Total',
            className: "small",
            Format: 'Currency',
            frozen: "frozen",
            alignFrozen: "right",
            hidden: permisoCostos,
            Sumary: 'sum',
        }
    ];

    const tableOrdenes = {
        Columns: columnOrdenes,
        Data: dataOrdenes,
        loading: loading,
        selected: selected,
        setSelected: setSelected,
        showModal: e => showModal(e),
    }

    const tableDetalle = {
        Columns: columnDetalle,
        Data: dataDetalle,
        loading: loading,
        selected: selectedDetalle,
        setSelected: setSelectedDetalle,
        showModal: e => showModal(e),
    }

    const showModal = (ordenCompras) => {
        setOrderToShow(ordenCompras)
        setOrdenDialog(true);
    }

    const onHideModalOC = () => {
        setOrdenDialog(false);
        setOrderToShow(undefined);
    }

    useEffect(() => {
        getInfo();
        setTitlePage('Ordenes de Compras');
    }, [])

    const items = [
        {
            className: "p-componentt",
            label: "Ingles",
            icon: "",
            command: () => {
                if (selected.length > 0) {
                    setLenguaje('en')
                    setShowReporte(true)
                    // window.open(`${process.env.REACT_APP_ENV}/OrdenCompras/print/${selected[0]?.PurchaseOrder}/1`, selected[0]?.PurchaseOrder, 'height=1200,width=1000')
                } else {
                    toastShow(toast, "warn", "Advertencia", "Seleccione una órden a imprimir");
                }

            },
        },
        {
            label: "Español",
            icon: "",
            command: () => {
                if (selected.length > 0) {
                    setLenguaje('es')
                    setShowReporte(true)
                    // window.open(`${process.env.REACT_APP_ENV}/OrdenCompras/print/${selected[0]?.PurchaseOrder}/2`, selected[0]?.PurchaseOrder, 'height=1200,width=1000')
                } else {
                    toastShow(toast, "warn", "Advertencia", "Seleccione una órden a imprimir");
                }
            },
        },
    ];



    return (
        <div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <ModalFull
                header='Orden de compras'
                visible={ordenDialog}
                onHide={onHideModalOC}
                contenido={
                    <OrdenesComprasCrud
                        PurchaseOrder={orderToShow}
                        ordenDialog={ordenDialog}
                        setOrdenDialog={setOrdenDialog}
                        habilitar={habilitar}
                        setHabilitar={setHabilitar} />
                }
            />

            <Card
                titulo={<div className='botones'>
                    <h3>Ordenes de Compras</h3>
                    <CalendarWeek
                        date={dates}
                        setDate={setDates}
                        loading={loading}
                        buscar={getInfo}
                        selectionMode='range'
                    />
                    <Button icon={'pi pi-plus'} onClick={e => showModal(null)} />

                    <div className="d-flex flex-row">
                        <SplitButton
                            label=""
                            icon="pi pi-print"
                            onClick={(e) => {
                                if (selected.length > 0) {
                                    setLenguaje('es')
                                    setShowReporte(true)
                                } else {
                                    toastShow(toast, "warn", "Advertencia", "Seleccione una órden a imprimir");
                                }
                            }}
                            model={items}
                        />
                    </div>
                    {/* <Button icon={'pi pi-print'} onClick={e => {
                        if(selected.length > 0 ){
                            window.open(`${process.env.REACT_APP_ENV}/OrdenCompras/print/${selected[0]?.PurchaseOrder}/2`, selected[0]?.PurchaseOrder, 'height=1200,width=1000')
                        }else{
                            toastShow(toast, 'warn', 'Advertencia', 'Seleccione una orden de compra')
                        }
                    }
                    } /> */}
                </div>}
                contenido={<div className='pt-4'>
                    <TabView>
                        <TabPanel header={'Ordenes'}>
                            <div className='pt-4' style={{ height: '83vh' }}>
                                <AgGrid table={tableOrdenes} />
                            </div>
                        </TabPanel>
                        <TabPanel header={'Detalle'}>
                            <div className='pt-4' style={{ height: '83vh' }}>
                                <AgGrid table={tableDetalle} />
                            </div>
                        </TabPanel>

                    </TabView>
                </div>}
            />

            {showReporte && (
                <OrdenesComprasReporte
                    showReporte={showReporte}
                    setShowReporte={setShowReporte}
                    selected={selected}
                    setSelected={setSelected}
                    lenguaje={lenguaje}
                    getInfo={getInfo}
                />
            )}


        </div>
    )
}

export default OrdenesComprasScreen